import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "add-page common-page"
};
const _hoisted_2 = {
  class: "form-items-container"
};
const _hoisted_3 = {
  class: "price-input-container"
};
const _hoisted_4 = {
  class: "price-input-container"
};
import { reactive, ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage, ElForm } from "element-plus";
import { UploadFilled } from "@element-plus/icons-vue";
import { addProductApi, getProductByIdApi, getProductCategoryListApi, updateProductByIdApi } from "@/service/modules/product";
import { getDictListById } from "@/service/modules/dict";
import { uploadFile } from "@/service/modules/upload";
export default /*@__PURE__*/_defineComponent({
  __name: 'goods-add',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const formRef = ref();
    // 表单数据
    const form = reactive({
      productName: "",
      images: [],
      categoryId: undefined,
      origin: "",
      isShelf: true,
      // operatorContact: "",
      price: 0,
      maxPrice: 0,
      productDetail: [],
      qualification: [],
      productAddress: "",
      smallprogramAddress: "",
      platformType: null,
      goodsTag: []
    });
    // 类目选项
    const categoryOptions = ref([{
      id: 1,
      name: "电子产品"
    }, {
      id: 2,
      name: "服装"
    }, {
      id: 3,
      name: "食品"
    }, {
      id: 4,
      name: "图书"
    }]);
    const props = {
      children: "secondCategory",
      label: "categoryName",
      value: "id",
      emitPath: false,
      leaf: ''
    };
    // 产地选项
    const originOptions = ref([{
      value: "cn",
      label: "中国"
    }, {
      value: "us",
      label: "美国"
    }, {
      value: "jp",
      label: "日本"
    }, {
      value: "kr",
      label: "韩国"
    }, {
      value: "eu",
      label: "欧洲"
    }]);
    // 添加图片文件列表状态
    const imageFileList = ref([]);
    // 资质文件列表
    const qualificationFiles = ref([]);
    //产品详情列表
    const productDetailFiles = ref([]);
    const isLoading = ref(false);
    const id = ref(null);
    // 表单验证规则
    const formRules = {
      productName: [{
        required: true,
        message: "请输入商品标题",
        trigger: "blur"
      }],
      images: [{
        required: true,
        message: "请上传商品图片",
        trigger: "blur"
      }],
      categoryId: [{
        required: true,
        message: "请选择商品类目",
        trigger: "change"
      }],
      origin: [{
        required: true,
        message: "请选择产地",
        trigger: "change"
      }],
      isShelf: [{
        required: true,
        message: "请选择是否上架",
        trigger: "change"
      }],
      price: [{
        required: true,
        message: "请输入产品价格",
        trigger: "blur"
      }],
      maxPrice: [{
        required: true,
        message: "请输入产品价格",
        trigger: "blur"
      }],
      productDetail: [{
        required: true,
        message: "请上传产品详情",
        trigger: "blur"
      }]
      // qualification: [
      //   { required: true, message: "请上传产品资质", trigger: "blur" },
      // ],
      // operatorContact: [
      //   { required: true, message: "请输入联系方式", trigger: "blur" },
      // ],
      // productAddress: [
      //   { required: true, message: "请输入购买链接", trigger: "blur" },
      // ],
      // platformType: [
      //   { required: true, message: "请选择平台", trigger: "blur" },
      // ],
    };
    // 平台选项
    const platformOptions = ref([{
      id: "jd",
      name: "京东"
    }, {
      id: "taobao",
      name: "淘宝"
    }, {
      id: "pdd",
      name: "拼多多"
    }]);
    getDictListById(17).then(res => {
      platformOptions.value = res.data;
    });
    // 产品标签
    const goodsTag = ref([]);
    getDictListById(19).then(res => {
      goodsTag.value = res.data;
    });
    async function getCategoryList() {
      try {
        let res = await getProductCategoryListApi();
        console.log(res);
        categoryOptions.value = res.data;
        // categoryOptions.value = res.data.map((item: any) => {
        //   return {
        //     id: item.id,
        //     name: item.categoryName,
        //   };
        // });
      } catch {}
    }
    // 替换原来的图片上传处理函数
    async function handleImageUpload(options) {
      const {
        file
      } = options;
      // 检查文件类型
      if (!file.type.includes("image/")) {
        ElMessage.error("请上传图片文件!");
        return;
      }
      // 检查文件大小
      if (file.size > 5 * 1024 * 1024) {
        ElMessage.error("文件大小不能超过5MB!");
        return;
      }
      // 创建图片URL
      // const imageUrl = URL.createObjectURL(file as Blob);
      try {
        const res = await uploadFile({
          file: options.file
        });
        if (!res.data[0]) {
          ElMessage.error("图片上传失败");
          return;
        }
        // 添加到form.images数组
        form.images.push({
          url: res.data[0],
          name: file.name,
          uid: file.uid
        });
        // 添加到文件列表显示
        imageFileList.value.push({
          name: file.name,
          url: res.data[0],
          uid: file.uid
        });
        ElMessage.success("图片上传成功");
      } catch {}
    }
    // 处理图片删除
    function handleImageRemove(file, fileList) {
      // 查找在imageFileList中的索引
      const fileIndex = imageFileList.value.findIndex(item => item.uid === file.uid);
      if (fileIndex !== -1) {
        // 从form.images中删除相应元素
        form.images.splice(fileIndex, 1);
        // 从imageFileList中删除元素（Element Plus会自动更新UI，但我们需要保持数据同步）
        imageFileList.value = fileList;
      }
    }
    // 上传产品详情
    async function uploadProductDetail(options) {
      const {
        file
      } = options;
      // 检查文件类型
      const validTypes = ["image/jpeg", "image/png"];
      if (!validTypes.includes(file.type)) {
        ElMessage.error("请上传jpg/png文件!");
        return;
      }
      // 检查文件大小
      if (file.size > 5 * 1024 * 1024) {
        ElMessage.error("文件大小不能超过5MB!");
        return;
      }
      try {
        const res = await uploadFile({
          file: options.file
        });
        if (!res.data[0]) {
          ElMessage.error("图片上传失败");
          return;
        }
        // 添加到form.productDetail数组
        form.productDetail.push({
          url: res.data[0],
          name: file.name,
          uid: file.uid
        });
        // 添加到文件列表显示
        productDetailFiles.value.push({
          name: file.name,
          url: res.data[0],
          uid: file.uid
        });
        ElMessage.success("图片上传成功");
      } catch {}
    }
    // 处理产品详情删除
    function handleProductDetailRemove(file, fileList) {
      const fileIndex = productDetailFiles.value.findIndex(item => item.uid === file.uid);
      if (fileIndex !== -1) {
        // 从form.images中删除相同位置的元素
        form.productDetail.splice(fileIndex, 1);
      }
    }
    // 上传资质文件
    async function uploadQualification(options) {
      const {
        file
      } = options;
      // 检查文件类型
      // const validTypes = ["image/jpeg", "image/png", "application/pdf"];
      // if (!validTypes.includes(file.type)) {
      //   ElMessage.error("请上传jpg/png/pdf文件!");
      //   return;
      // }
      // 检查文件大小
      // if (file.size > 5 * 1024 * 1024) {
      //   ElMessage.error("文件大小不能超过5MB!");
      //   return;
      // }
      try {
        const res = await uploadFile({
          file: options.file
        });
        if (!res.data[0]) {
          ElMessage.error("图片上传失败");
          return;
        }
        // 添加到form.qualification数组
        form.qualification.push({
          url: res.data[0],
          name: file.name,
          uid: file.uid
        });
        // 添加到文件列表显示
        qualificationFiles.value.push({
          name: file.name,
          url: res.data[0],
          uid: file.uid
        });
        ElMessage.success("图片上传成功");
      } catch {}
    }
    // 处理资质文件删除
    function handleQualificationRemove(file, fileList) {
      const fileIndex = qualificationFiles.value.findIndex(item => item.uid === file.uid);
      if (fileIndex !== -1) {
        // 从form.images中删除相同位置的元素
        form.qualification.splice(fileIndex, 1);
      }
    }
    function handleToBack() {
      if (isLoading.value) {
        return ElMessage.warning("正在保存...");
      }
      router.back();
    }
    function handleSubmit() {
      // console.log("提交表单数据:", form);
      // return
      formRef.value?.validate(valid => {
        if (valid) {
          // 添加价格验证逻辑
          if (form.price > form.maxPrice && form.maxPrice > 0) {
            return ElMessage.error("最小价格不能大于最大价格");
          }
          submit();
        }
      });
    }
    async function submit() {
      isLoading.value = true;
      try {
        // 模拟API调用
        console.log(123, "提交的产品数据:", form);
        const id = route?.query?.id;
        let data = {
          ...form,
          goodsTag: form.goodsTag.join(','),
          productImages: [...form.images.map((item, index) => {
            return {
              url: item.url,
              typeId: index === 0 ? 1 : 2,
              orderIndex: index,
              productId: id
            };
          }), ...form.productDetail.map((item, index) => {
            return {
              url: item.url,
              typeId: 3,
              orderIndex: index,
              productId: id
            };
          }), ...form.qualification.map((item, index) => {
            return {
              url: item.url,
              typeId: 4,
              orderIndex: index,
              productId: id
            };
          })]
        };
        const query = route.query;
        if (query?.id) {
          let res = await updateProductByIdApi(query.id, data);
          ElMessage.success("产品更新成功");
        } else {
          let res = await addProductApi(data);
          ElMessage.success("产品发布成功");
        }
        setTimeout(() => {
          router.push("/product/goods");
        }, 1000);
      } catch (e) {
        console.error("发布失败:", e);
        ElMessage.error("发布失败，请重试");
      } finally {
        isLoading.value = false;
      }
    }
    onMounted(async () => {
      getCategoryList();
      // 如果是编辑模式，获取产品数据
      const query = route.query;
      if (query?.id) {
        id.value = query.id;
        // 获取产品详情的逻辑
        let res = await getProductByIdApi(id.value);
        console.log(123, res);
        form.productName = res.data.productName;
        form.categoryId = res.data.categoryId;
        form.origin = res.data.origin;
        form.isShelf = res.data.isShelf;
        // form.operatorContact = res.data.operatorContact;
        form.price = res.data.price;
        form.maxPrice = res.data.maxPrice;
        form.productAddress = res.data?.productAddress;
        form.smallprogramAddress = res.data.smallprogramAddress;
        form.platformType = res.data?.platformType?.toString();
        form.goodsTag = res.data.goodsTag?.split(',') || [];
        form.images = res.data.productImages.filter(item => item.typeId === 1 || item.typeId === 2);
        form.productDetail = res.data.productImages.filter(item => item.typeId === 3);
        form.qualification = res.data.productImages.filter(item => item.typeId === 4);
        imageFileList.value = form.images.map(item => {
          return {
            name: item.name,
            url: item.url,
            uid: item.url
          };
        });
        productDetailFiles.value = form.productDetail.map(item => {
          return {
            name: item.name,
            url: item.url,
            uid: item.url
          };
        });
        qualificationFiles.value = form.qualification.map(item => {
          return {
            name: item.name,
            url: item.url,
            uid: item.url
          };
        });
        // 初始化时，如果有图片数据，需要更新imageFileList
        // 这里只是示例逻辑，实际需要根据获取的数据来处理
        // form.images.forEach((url, index) => {
        //   if (url) {
        //     imageFileList.value.push({
        //       name: `图片${index + 1}`,
        //       url: url
        //     });
        //   }
        // });
      }
    });
    return (_ctx, _cache) => {
      const _component_Plus = _resolveComponent("Plus");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_cascader = _resolveComponent("el-cascader");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[19] || (_cache[19] = _createElementVNode("div", {
        class: "page-title"
      }, "发布产品", -1)), _createVNode(_unref(ElForm), {
        "label-position": "left",
        "label-width": "120px",
        rules: formRules,
        ref_key: "formRef",
        ref: formRef,
        model: form
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: `图片上传 (${imageFileList.value.length}/5)`,
          prop: "images"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            class: "product-image-upload",
            "list-type": "picture-card",
            limit: 5,
            action: "#",
            "http-request": handleImageUpload,
            "file-list": imageFileList.value,
            "on-remove": handleImageRemove,
            multiple: ""
          }, {
            tip: _withCtx(() => _cache[10] || (_cache[10] = [_createElementVNode("div", {
              class: "el-upload__tip"
            }, " 请上传产品图片，第一张将作为主图（最多5张） ", -1)])),
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              class: "el-icon--upload"
            }, {
              default: _withCtx(() => [_createVNode(_component_Plus)]),
              _: 1
            })]),
            _: 1
          }, 8, ["file-list"])]),
          _: 1
        }, 8, ["label"]), _createVNode(_component_el_form_item, {
          label: "商品标题",
          prop: "productName"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.productName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.productName = $event),
            placeholder: "请输入商品标题"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form_item, {
          label: "商品类目",
          prop: "categoryId",
          class: "form-item-fixed"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_cascader, {
            modelValue: form.categoryId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.categoryId = $event),
            options: categoryOptions.value,
            props: props
          }, null, 8, ["modelValue", "options"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "选择产地",
          prop: "origin",
          class: "form-item-fixed"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.origin,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.origin = $event),
            placeholder: "请输入产地"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "是否上架",
          prop: "isShelf",
          class: "form-item-fixed"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: form.isShelf,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.isShelf = $event),
            placeholder: "请选择",
            style: {
              "width": "100%"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "上架",
              value: true
            }), _createVNode(_component_el_option, {
              label: "下架",
              value: false
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "产品价格(最小)",
          prop: "price",
          class: "form-item-fixed"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input_number, {
            modelValue: form.price,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.price = $event),
            precision: 2,
            min: 0,
            step: 1,
            style: {
              "width": "100%"
            },
            "controls-position": "right"
          }, null, 8, ["modelValue"]), _cache[11] || (_cache[11] = _createElementVNode("span", {
            class: "unit"
          }, "元", -1))])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "产品价格(最大)",
          prop: "maxPrice",
          class: "form-item-fixed"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_input_number, {
            modelValue: form.maxPrice,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.maxPrice = $event),
            precision: 2,
            min: 0,
            step: 1,
            style: {
              "width": "100%"
            },
            "controls-position": "right"
          }, null, 8, ["modelValue"]), _cache[12] || (_cache[12] = _createElementVNode("span", {
            class: "unit"
          }, "元", -1))])]),
          _: 1
        })]), _createElementVNode("div", null, [_createVNode(_component_el_form_item, {
          label: "产品标签",
          style: {
            "width": "50%"
          },
          prop: "goodsTag"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: form.goodsTag,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.goodsTag = $event),
            placeholder: "请选择产品标签",
            "value-key": "id",
            multiple: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goodsTag.value, (item, index) => {
              return _openBlock(), _createBlock(_component_el_option, {
                value: item.id,
                key: item.id,
                label: item.name
              }, null, 8, ["value", "label"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })]), _createElementVNode("div", null, [_createVNode(_component_el_form_item, {
          label: "购买链接",
          style: {
            "width": "50%"
          },
          prop: "productAddress"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.productAddress,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.productAddress = $event),
            placeholder: "请输入购买链接"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "小程序链接",
          style: {
            "width": "50%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.smallprogramAddress,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.smallprogramAddress = $event),
            placeholder: "请输入小程序链接"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "平台",
          style: {
            "width": "50%"
          },
          prop: "platformType"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: form.platformType,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.platformType = $event),
            placeholder: "请选择平台",
            "value-key": "id"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(platformOptions.value, (item, index) => {
              return _openBlock(), _createBlock(_component_el_option, {
                value: item.id,
                key: item.id,
                label: item.name
              }, null, 8, ["value", "label"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })]), _createVNode(_component_el_form_item, {
          label: "产品详情",
          prop: "productDetail"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            class: "qualification-upload",
            "list-type": "picture-card",
            drag: "",
            action: "#",
            "http-request": uploadProductDetail,
            limit: 5,
            "file-list": productDetailFiles.value,
            multiple: "",
            "on-remove": handleProductDetailRemove
          }, {
            tip: _withCtx(() => _cache[13] || (_cache[13] = [_createElementVNode("div", {
              class: "el-upload__tip"
            }, "支持jpg/png文件，不超过5MB", -1)])),
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              class: "el-icon--upload"
            }, {
              default: _withCtx(() => [_createVNode(_unref(UploadFilled))]),
              _: 1
            }), _cache[14] || (_cache[14] = _createElementVNode("div", {
              class: "upload-text"
            }, "点击或拖拽文件至此处上传", -1))]),
            _: 1
          }, 8, ["file-list"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "产品资质",
          prop: "qualification"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            class: "qualification-upload",
            "list-type": "picture-card",
            drag: "",
            action: "#",
            "http-request": uploadQualification,
            "file-list": qualificationFiles.value,
            multiple: "",
            "on-remove": handleQualificationRemove
          }, {
            tip: _withCtx(() => _cache[15] || (_cache[15] = [_createElementVNode("div", {
              class: "el-upload__tip"
            }, " 支持扩展名：doc .docx .pdf .jpg .png ", -1)])),
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              class: "el-icon--upload"
            }, {
              default: _withCtx(() => [_createVNode(_unref(UploadFilled))]),
              _: 1
            }), _cache[16] || (_cache[16] = _createElementVNode("div", {
              class: "upload-text"
            }, "点击或拖拽文件至此处上传", -1))]),
            _: 1
          }, 8, ["file-list"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "danger",
            style: {
              "margin-right": "10px"
            },
            size: "default",
            onClick: handleToBack
          }, {
            default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode("取消")])),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            size: "default",
            loading: isLoading.value,
            onClick: handleSubmit
          }, {
            default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode("提交")])),
            _: 1
          }, 8, ["loading"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]);
    };
  }
});